var map = {
	"./book/book_1_en.png": "e436",
	"./book/book_1_zh.png": "58c4",
	"./book/book_2_en.png": "a02b",
	"./book/book_2_zh.png": "063d",
	"./book/book_3_en.png": "0d22",
	"./book/book_3_zh.png": "9215",
	"./book/book_4_en.png": "2268",
	"./book/book_4_zh.png": "4cd7",
	"./book/book_5_en.png": "2470",
	"./book/book_5_zh.png": "9bca",
	"./book/book_6_en.png": "4098",
	"./book/book_6_zh.png": "76b8",
	"./bookPC/book_1_en.png": "cc40",
	"./bookPC/book_1_zh.png": "4b31",
	"./bookPC/book_2_en.png": "7a15",
	"./bookPC/book_2_zh.png": "67b2",
	"./bookPC/book_3_en.png": "446f",
	"./bookPC/book_3_zh.png": "06c8",
	"./bookPC/book_4_en.png": "84af",
	"./bookPC/book_4_zh.png": "a543",
	"./bookPC/book_5_en.png": "5cd7",
	"./bookPC/book_5_zh.png": "ae4a",
	"./bookPC/book_6_en.png": "d650",
	"./bookPC/book_6_zh.png": "95cd",
	"./introduction/introduction_1.png": "382d",
	"./introduction/introduction_2.png": "d0d8",
	"./introduction/introduction_3.png": "fda5",
	"./introduction/introduction_4.png": "3c27",
	"./introduction/introduction_5.png": "0fd7",
	"./introduction/introduction_6.png": "a1e1",
	"./introduction/introduction_7.png": "5ab9",
	"./introductionPC/introduction_1.png": "678a",
	"./introductionPC/introduction_2.png": "bdd8",
	"./introductionPC/introduction_3.png": "ef4e",
	"./introductionPC/introduction_4.png": "e3b1",
	"./introductionPC/introduction_5.png": "b044",
	"./introductionPC/introduction_6.png": "a0bb",
	"./introductionPC/introduction_7.png": "bfdf",
	"./last_en.png": "ff39",
	"./last_zh.png": "e6af",
	"./next_en.png": "43cf",
	"./next_zh.png": "ac28",
	"./takeLeave/takeLeave_1_en.png": "7047",
	"./takeLeave/takeLeave_1_zh.png": "6417",
	"./takeLeave/takeLeave_2_en.png": "4097",
	"./takeLeave/takeLeave_2_zh.png": "40df",
	"./takeLeave/takeLeave_3_en.png": "b3b7",
	"./takeLeave/takeLeave_3_zh.png": "19ad",
	"./takeLeave/takeLeave_4_en.png": "8e80",
	"./takeLeave/takeLeave_4_zh.png": "261f",
	"./takeLeavePC/takeLeave_1_en.png": "bb22",
	"./takeLeavePC/takeLeave_1_zh.png": "0871",
	"./takeLeavePC/takeLeave_2_en.png": "26c4",
	"./takeLeavePC/takeLeave_2_zh.png": "9c81",
	"./takeLeavePC/takeLeave_3_en.png": "5223",
	"./takeLeavePC/takeLeave_3_zh.png": "658a",
	"./takeLeavePC/takeLeave_4_en.png": "f227",
	"./takeLeavePC/takeLeave_4_zh.png": "0d17",
	"./takeLeavePC/takeLeave_5_en.png": "17d7",
	"./takeLeavePC/takeLeave_5_zh.png": "601f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e8cc";